module.exports = __webpack_public_path__ + "static/media/Imagenes-Blog2-1024x691.1cf642cc.png";